import { useRecoilValue, useSetRecoilState } from "recoil";
import { appState } from "@store/recoil";
import { useSelector } from "react-redux";
import { homeStateSelector } from "@/store/redux/modules/home";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import { Skeleton } from "antd-mobile";
import { airQualityRoute, baseDeilyDetailPath, dailyRoute, homeRoute, hourlyRoute, sunMoonRoute } from "@/router";
import { useTranslation } from "react-i18next";
export const fetchDataMap: any = {};
const Navigation: React.FC = () => {
  const homeState = useSelector(homeStateSelector);
  const { pathname } = useLocation();
  const setAppState = useSetRecoilState(appState.appAtom);
  const getAppState = useRecoilValue(appState.appAtom);
  const navigate = useNavigate();
  const setThemeColor = (_pathname: string | string[]) => {
    const appBgUrl =
      homeState?.info?.weatherBg || LocalStorage.getItem("info")?.weatherBg
        ? import.meta.env.VITE_API_ATRGET +
          (homeState?.info?.weatherBg || LocalStorage.getItem("info")?.weatherBg) +
          (isDevEnv ? "?test=1" : "")
        : "";
    setAppState({
      ...getAppState,
      appBgImageUrl: appBgUrl,
    });
  };
  useEffect(() => {
    setThemeColor(pathname);
  }, [pathname, homeState.info]);

  const nav_style = {
    backgroundImage: `url(${getAppState.appBgImageUrl})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "left bottom",
  };
  const handleClick = (path: string) => {
    return (e: any) => {
      // @ts-ignore
      !isDevEnv && gtag("event", "clickNavi", { navi: path });
      e.preventDefault();
      navigate(path, {
        replace: false,
      });
    };
  };
  const navItemClass = "inline-block rounded-30 p-[0_10px] h-30 lh-30 mr-8 color-[#fff]";
  const activeClass = "bg-[rgba(255,255,255,0.4)]";
  const { t: $t } = useTranslation();

  // 单页面应用
  return isEmptyType(homeState) ? (
    <Skeleton
      animated
      style={
        pathname.includes(baseDeilyDetailPath)
          ? {
              "--width": "100%",
              "--height": "76px",
              "--border-radius": "0px",
            }
          : {
              "--width": "100%",
              "--height": "50px",
              "--border-radius": "0px",
            }
      }
    />
  ) : (
    <div
      className="overflow-x-scroll overflow-y-hidden whitespace-nowrap inline-block w-full h-50 lh-50 p-[0_10px] text-13"
      style={nav_style}
    >
      <div
        onClick={handleClick(homeRoute.path)}
        className={classNames([pathname.indexOf(homeRoute.path) === 0 ? activeClass : "", navItemClass])}
      >
        {$t("title33")}
      </div>
      <div
        onClick={handleClick(hourlyRoute.path)}
        className={classNames([pathname.indexOf(hourlyRoute.path) === 0 ? activeClass : "", navItemClass])}
      >
        {$t("title34")}
      </div>
      <div
        onClick={handleClick(dailyRoute.path)}
        className={classNames([pathname.indexOf(dailyRoute.path) === 0 ? activeClass : "", navItemClass])}
      >
        {$t("title35")}
      </div>
      <div
        onClick={handleClick(sunMoonRoute.path)}
        className={classNames([pathname.indexOf(sunMoonRoute.path) === 0 ? activeClass : "", navItemClass])}
      >
        {$t("title36")}
      </div>
      {isDevEnv && (
        <div
          onClick={handleClick(airQualityRoute.path)}
          className={classNames([pathname.indexOf(airQualityRoute.path) === 0 ? activeClass : "", navItemClass])}
        >
          {$t("title37")}
        </div>
      )}
    </div>
  );
};
export default Navigation;
